import { requireGuestUser } from '#utils/auth.ts';

export function loader() {
  requireGuestUser();
  return null;
}
